import CARD_TYPES from './cardTypes';
import config from '../../appConfig';
import Http from '../../shared/http-service';
import dateUtility from '../../shared/dateUtility';
import _ from 'lodash';
import {CARD_COMPANIES} from '../../join-commute/helpers/commonHelper';

export const NEW_CARD_ID = 'NEW_CARD_ID';

let creditCardService = {};

creditCardService.isNumber = value => {
  return /^\d*$/.test(value);
};

creditCardService.cardTypeForValue = value => {
  return CARD_TYPES.find(type => type.pattern.test(value));
};

creditCardService.cardTypeForBrand = (brand = '') => {
  const card = CARD_TYPES.find(
    type => type.type.toUpperCase() === brand.toUpperCase()
  );
  return card || _.last(CARD_TYPES);
};

creditCardService.scheduleLookup = [];
creditCardService.scheduleForCard = value => {
  if (!creditCardService.scheduleLookup.length || !value || value.length < 6) {
    return { next: '', every: '' };
  }

  return creditCardService.scheduleLookup.find(entry =>
    value.startsWith(entry.code)
  );
};

creditCardService.findValidCardType = type => {
  return CARD_TYPES.filter(type);
};

creditCardService.isCvcValid = (validLength, value) => {
  let pattern = new RegExp('^\\d{0,' + validLength + '}$');
  return pattern.test(value);
};

creditCardService.getImage = cardType => {
  if(cardType){    
    const card = CARD_TYPES.filter(
      card => card.type === cardType.toLowerCase()
    ).reduce((acc, cur) => cur, CARD_TYPES.find(c => c.type === ''));
  
    return card.imgSrc;
  } else
  return '';
};

creditCardService.getCardTypeJoinCommute = value => {
  return CARD_COMPANIES.find(type => type.pattern.test(value));
};

creditCardService.luhn = function(ccNum) {
  const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let len = ccNum.length;
  let bit = 1;
  let sum = 0;
  let val;

  while (len) {
    val = parseInt(ccNum.charAt(--len), 10);
    // eslint-disable-next-line
    sum += (bit ^= 1) ? arr[val] : val;
  }

  return sum && sum % 10 === 0;
};

creditCardService.retrieveSchedule = async () => {
  const recurringLookupUrl = `${config.kongApiBaseUrl}/payment/recurringChargeInformation`;
  try {
    let recurring = await Http.get(recurringLookupUrl);

    creditCardService.scheduleLookup = recurring.recurringChargeInformation
      .map(entry => ({
        code: entry.binCode,
        next: dateUtility.parseDateAsMonthDayYear(
          entry.nextRecurringChargeDate
        ),
        every: dateUtility.parseDayAsOrdinal(entry.nextRecurringChargeDate),
        brand: entry.cardType
      }))
      .sort((cardA, cardB) => cardB.code.length - cardA.code.length);
  } catch (e) {
    return null;
  }
};

creditCardService.getExpirationYear = expString => {
  return expString.substring(2, expString.length);
};

creditCardService.getExpirationMonth = expString => {
  return expString.substring(0, 2);
};

creditCardService.createExpirationString = (month, year) => {
  let twoCharYear =
    year.toString().length === 2
      ? year
      : year.toString().substring(2, year.length);

  return `${month}${twoCharYear}`;
};

creditCardService.checkIfFederal = (value, binNumbers) => {
  const val = value.replace(' ','');
  const sixDigits = val.slice(0,6);
  return binNumbers.includes(sixDigits);
}


function findMatchingBin(binArray, inputBin) {
  var result = {
    isFederal: false,
    mayBeFedCommuter: false,
    mayBeRetailCommuter: false
  }
  const binStr = inputBin.toString();
  // First, try full 8-digit match
  let matches = binArray.filter(obj => obj.binCode === binStr);

  // If no matches, try first 6 digits
  if (matches.length === 0 && binStr.length >= 6) {
      const bin6 = binStr.slice(0, 6);
      matches = binArray.filter(obj => obj.binCode === bin6);
  }

  // Evaluate matches
  if (matches.length === 2) {
    result.mayBeFedCommuter = true
  } else if (matches.length === 1) {
      const match = matches[0];
      if (match.isFederalBenefitCard) {
         result.isFederal = true;
      } else {
        result.mayBeRetailCommuter = true;
      }
  }else{
    if(/^\d+$/.test(inputBin)){
      result.mayBeRetailCommuter =  true
    }
  }

  // If no valid matches
  return result;
}

creditCardService.checkIfFederalOrCommuter = (value, binNumbers, binNumberArray) => {
  const val = value.replace(' ','');
  const eightDigits = val.slice(0,8);
  var results = findMatchingBin(binNumberArray,eightDigits);
  return results;
}


function findMatchingBinBackup(binArray, inputBin) {
  var result = {
    isFederal: false
  }
  const binStr = inputBin.toString();
  // First, try full 8-digit match
  let matches = binArray.filter(obj => obj.binCode === binStr);

  // If no matches, try first 6 digits
  if (matches.length === 0 && binStr.length >= 6) {
      const bin6 = binStr.slice(0, 6);
      matches = binArray.filter(obj => obj.binCode === bin6);
  }

  // Evaluate matches
  if (matches.length) {
    result.isFederal = true
  }

  // If no valid matches
  return result;
}

creditCardService.checkIfFederalOrCommuterBackup = (value, binNumbers, binNumberArray) => {
  const val = value.replace(' ','');
  const eightDigits = val.slice(0,8);
  var results = findMatchingBinBackup(binNumberArray,eightDigits);
  return results;
}


creditCardService.checkCVV = (value, cardNumber) => {
  let type = creditCardService.getCardTypeJoinCommute(cardNumber);
  if(creditCardService.isCvcValid(type.cvcLength,value)){
    return true;
  }
  return false;
}

creditCardService.checkCVVForBrand = (cvv, brand) => {
  const type = creditCardService.cardTypeForBrand(brand);
  if(creditCardService.isCvcValid(type.cvcLength, cvv)){
    return true;
  }
  return false;
}

function findBinMatch(bins, searchBin) {
  // Step 1: Try full 8-digit match
  let match = bins.find(item => (item.binCode === searchBin && item.isFederalBenefitCard));

  if (match) {
    return match;
  }

  // Step 2: Try first 6 digits
  const sixDigit = searchBin.slice(0, 6);
  match = bins.find(item => (item.binCode === sixDigit && item.isFederalBenefitCard));

  return match || null; // return null if nothing found
}

creditCardService.getRecommendedStartRange = (value, binArray) => {
  const val = value.replace(' ','');
  const searchBin = val.slice(0,8);
  const result = findBinMatch(binArray, searchBin);
  var dateRange = (result && result.isFederalBenefitCard) ? result.recommendedStartRange : null;
  return dateRange;
}

export default creditCardService;
